import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: AppRoutesName.FR.LOGIN,
    loadComponent: () =>
      import('./login-2.component').then((m) => m.FuseLogin2Component),
  },
  {
    path: AppRoutesName.EN.LOGIN,
    loadComponent: () =>
      import('./login-2.component').then((m) => m.FuseLogin2Component),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Login2Module {}
